var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 6,
    fill: "#1D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4805 25.2028C20.7983 25.2028 24.7995 19.1391 24.7995 13.8838C24.7995 13.7106 24.7995 13.5373 24.7913 13.3723C25.5668 12.8113 26.2433 12.1101 26.7795 11.3098C26.07 11.6233 25.3028 11.8378 24.4943 11.9368C25.3193 11.4418 25.9463 10.6663 26.2433 9.73406C25.476 10.1878 24.6263 10.5178 23.7188 10.6993C22.9928 9.92381 21.9615 9.44531 20.8148 9.44531C18.6203 9.44531 16.8383 11.2273 16.8383 13.4218C16.8383 13.7353 16.8713 14.0406 16.9455 14.3293C13.6373 14.1643 10.7085 12.5803 8.74502 10.1713C8.40677 10.7571 8.20877 11.4418 8.20877 12.1678C8.20877 13.5456 8.91002 14.7666 9.98252 15.4761C9.33077 15.4596 8.72027 15.2781 8.18402 14.9811C8.18402 14.9976 8.18402 15.0141 8.18402 15.0306C8.18402 16.9611 9.55352 18.5616 11.3768 18.9328C11.0468 19.0236 10.692 19.0731 10.329 19.0731C10.0733 19.0731 9.82577 19.0483 9.57827 18.9988C10.0815 20.5828 11.55 21.7296 13.2908 21.7626C11.9295 22.8268 10.2135 23.4621 8.34902 23.4621C8.02727 23.4621 7.71377 23.4456 7.40027 23.4043C9.14102 24.5428 11.2365 25.2028 13.4805 25.2028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon02);
export default __webpack_public_path__ + "static/media/social-icon-02.09dafcf6a096a45474dfe149bb0fdfd7.svg";
export { ForwardRef as ReactComponent };